import React from 'react';
import './PanelButton.scss';

type PanelButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  children: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export default function PanelButton({ children, onClick, ...props }: PanelButtonProps) {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      onClick(event);
    }
    event.currentTarget.blur();
  };

  return (
    <button
      {...props}
      onClick={handleClick}
      className={`panel-button ${props.className || ''}`}
      style={{
        ...props.style
      }}
    >
      {children}
    </button>
  );
}
